import { DataTable } from '@/components/data-table'
import { openSheet } from '@/features/ui/store'
import type { Table } from '@/libs/table'
import { useCallback } from 'react'
import type { Customer } from '../domain/customer'
import { EmptyState, NoResults } from './empty-states'
import { useCustomerParams } from './use-customer-params'
import { GLOBAL_SHEET_IDS } from '@/features/ui/hooks/use-sheet'

type Props = {
	data: Customer[]
	hasFilters: boolean
	table: Table<Customer>
}

const sortableColumns = new Set(['name', 'email', 'country', 'website'])

const CustomersTable = ({ data, hasFilters, table }: Props) => {
	const { setParams, sortBy, sortDir } = useCustomerParams()

	const handleSort = useCallback(
		(key: string) => {
			if (sortBy !== key) return setParams({ sortBy: key, sortDir: 'asc' })
			if (sortDir === 'asc') return setParams({ sortBy: key, sortDir: 'desc' })
			setParams({ sortBy: null, sortDir: null })
		},
		[sortBy, sortDir, setParams],
	)

	if (!data.length && hasFilters) return <NoResults />
	if (!data.length) return <EmptyState />

	return (
		<DataTable
			table={table}
			sortBy={sortBy}
			sortDir={sortDir}
			sortableColumns={sortableColumns}
			onSort={handleSort}
			onRowClick={id => openSheet(GLOBAL_SHEET_IDS.CUSTOMER_EDIT, id)}
			height='calc(100vh - 200px)'
		/>
	)
}

export { CustomersTable }
